﻿import * as main  from  "./src/main";
declare let ds_info;

main.rendre("tileBox", ds_info);

